<script lang="ts">
	import { isReadyToInitializeModalsStore, modalStore } from 'src/stores/ui/modal_states';
	import { app, os } from 'src/stores/session/native-bridge';
	import { force_go_back } from 'src/services/native_container_requests_android';
	import { initializeModalManager } from 'src/services/modal-manager';

	modalStore.subscribe((modals) => {
		console.log('Current active modals:', modals);
		if (modals.length === 1 && $app && $os !== 'IOS') {
			force_go_back(true); // if it is only one modal we can use force_go_back for Android
		}
	});

	isReadyToInitializeModalsStore.subscribe((isReady) => {
		if (isReady) {
			initializeModalManager();
		}
	});
</script>

{#each $modalStore as modal (modal.id)}
	<svelte:component
		this={modal.component}
		{...modal.props}
		on:close={() => modalStore.hideModal(modal.id)}
	/>
{/each}
